import script from "./OrderContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderContainer.vue?vue&type=script&setup=true&lang=js"

import "./OrderContainer.vue?vue&type=style&index=0&id=3c84658e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c84658e"]])

export default __exports__